import styled from "styled-components"

export const Avatar = styled.img<{ src?: string; size?: string; margin?: string }>`
  border-radius: 100%;
  border: 0px solid;
  height: ${props => (props.size && props.size) || "3em"};
  width: ${props => (props.size && props.size) || "3em"};
  object-fit: cover;
  margin: ${props => (props.margin && props.margin) || "0 1rem"};
`
